import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div<{ size?: 'small' | 'medium' | 'large' }>`
  display: inline-block;
  width: ${props => {
    switch (props.size) {
      case 'small': return '16px';
      case 'large': return '32px';
      default: return '24px';
    }
  }};
  height: ${props => {
    switch (props.size) {
      case 'small': return '16px';
      case 'large': return '32px';
      default: return '24px';
    }
  }};
`;

const Spinner = styled.div<{ size?: 'small' | 'medium' | 'large' }>`
  width: 100%;
  height: 100%;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #FF9900;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: #6b7280;
  text-align: center;
`;

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'large', text }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <SpinnerContainer size={size}>
        <Spinner size={size} />
      </SpinnerContainer>
      {text && <LoadingText>{text}</LoadingText>}
    </div>
  );
};

export default LoadingSpinner; 